import { media, projectUrl } from '../config/site';

export function FeaturedProject() {
  return (
    <section className="project section-axis" id="project" aria-labelledby="project-title">
      <div className="page-shell section-frame" data-reveal>
        <div className="project-head">
          <div>
            <span className="eyebrow">Избранный проект</span>
            <h2 id="project-title">In <em>Balance.</em></h2>
          </div>
          <p>Сайт для студии пилатеса и физиотерапии в Даугавпилсе.</p>
        </div>

        <a className="project-media" href={projectUrl} target="_blank" rel="noreferrer" aria-label="Открыть сайт In Balance в новой вкладке">
          <picture>
            <img
              src={media.inBalanceScreenshot.src}
              srcSet={media.inBalanceScreenshot.srcSet}
              sizes="(max-width: 767px) 90vw, 55vw"
              width={media.inBalanceScreenshot.width}
              height={media.inBalanceScreenshot.height}
              alt="Главная страница сайта студии In Balance"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </a>

        <div className="project-foot">
          <p>Современная подача с акцентом на философию студии и удобный путь к знакомству с услугами.</p>
          <p><span>Проект</span>Website · Digital presentation<br />Daugavpils, Latvia</p>
          <a className="text-link action-link" href={projectUrl} target="_blank" rel="noreferrer">Смотреть сайт <span aria-hidden="true">→</span></a>
        </div>
      </div>
    </section>
  );
}
